import { render, staticRenderFns } from "./OilMakerAppUM.vue?vue&type=template&id=bf52ca16&scoped=true&"
import script from "./OilMakerAppUM.vue?vue&type=script&lang=js&"
export * from "./OilMakerAppUM.vue?vue&type=script&lang=js&"
import style0 from "./OilMakerAppUM.vue?vue&type=style&index=0&id=bf52ca16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf52ca16",
  null
  
)

export default component.exports